import { List } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TypesenseInstantSearch, {
  TypesenseContext,
} from "components/context/TypesenseInstantSearch";
import useQueryStringState from "components/hooks/useQueryStringState";
import useInstantSearchConfig from "components/shared/useInstantSearchConfig";
import { TypesenseInfiniteScrollButton } from "components/ui/atoms/Button";
import FilterAndSort from "components/ui/molecules/FilterAndSort";
import Layout from "components/ui/molecules/Layout";
import PeopleHitShort from "models/people/PeopleHitShort";
import PeopleSortForm from "models/people/PeopleSortForm";
import { useContext, useEffect, useState } from "react";
import { useInfiniteHits } from "react-instantsearch";
import { useNavigate } from "react-router-dom";

const InnerPeople = ({}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [state, setState] = useQueryStringState();
  const { typesenseEnv } = useContext(TypesenseContext);
  const { applyState } = useInstantSearchConfig({
    sortBy: [{ value: `${typesenseEnv}_people`, label: "People" }],
  });
  const { results } = useInfiniteHits();

  useEffect(() => {
    applyState(state);
  }, [state]);

  return (
    <Layout container hideBreadcrumbs>
      <Layout title color={theme.palette_custom.lightGreen}>
        People
      </Layout>
      <Layout content>
        <FilterAndSort
          SortForm={PeopleSortForm}
          state={state}
          setState={setState}
          count={results?.nbHits}
        />
      </Layout>
      <Layout content>
        <List>
          {results.hits.map((hit) => (
            <PeopleHitShort
              key={hit.id}
              onClick={(id) => navigate(`/people/${id}`)}
              hit={hit}
              sx={{
                border: `0.5px solid ${theme.palette_custom.darkBlue}`,
                borderRadius: "4px",
                marginBottom: 1,
              }}
            />
          ))}
        </List>
        <TypesenseInfiniteScrollButton />
      </Layout>
    </Layout>
  );
};

const People = () => {
  const searchClient = useContext(TypesenseContext);
  const [key, setKey] = useState(0);

  //key is the only simple way to refresh infinitHits state contained in InnerNote
  const refresh = () => {
    searchClient.clearCache();
    setKey(key + 1);
  };

  return (
    <TypesenseInstantSearch indexName="people">
      <InnerPeople key={key} clearTypesensCache={refresh} />
    </TypesenseInstantSearch>
  );
};

export default People;
